import { apiClient } from './apiClient';

class AgeGroupsService {
  constructor() {
    // nutzt apiClient
  }

  // Alle Altersgruppen abrufen
  async getAllAgeGroups() {
    try {


      const result = await apiClient.get('/age-groups');

      return {
        success: true,
        data: result,
        total: Array.isArray(result) ? result.length : 0
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: []
      };
    }
  }

  // Altersgruppe nach ID abrufen
  async getAgeGroupById(id) {
    try {


      const result = await apiClient.get(`/age-groups/${id}`);

      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Altersgruppe nach Name abrufen
  async getAgeGroupByName(name) {
    try {


      // Suche nach Altersgruppe mit diesem Namen
      const allAgeGroups = await this.getAllAgeGroups();
      if (!allAgeGroups.success) {
        throw new Error('Fehler beim Laden der Altersgruppen');
      }

      const ageGroup = allAgeGroups.data.find(ag => ag.name === name);

      if (!ageGroup) {
        return {
          success: false,
          error: 'Altersgruppe nicht gefunden',
          data: null
        };
      }

      return {
        success: true,
        data: ageGroup
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Altersgruppe für ein bestimmtes Alter finden
  async getAgeGroupForAge(age) {
    try {


      const result = await apiClient.get(`/age-groups/for-age/${age}`);

      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Altersgruppen nach Geschlecht abrufen (falls später benötigt)
  async getAgeGroupsByGender(gender) {
    try {


      // Suche nach Altersgruppen mit diesem Geschlecht
      const allAgeGroups = await this.getAllAgeGroups();
      if (!allAgeGroups.success) {
        throw new Error('Fehler beim Laden der Altersgruppen');
      }

      const ageGroups = allAgeGroups.data.filter(ag =>
        ag.gender === gender || ag.gender === 'mixed'
      );

      return {
        success: true,
        data: ageGroups,
        total: ageGroups.length
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: []
      };
    }
  }

  // Neue Altersgruppe erstellen
  async createAgeGroup(ageGroupData) {
    try {


      const result = await apiClient.post('/age-groups', ageGroupData);

      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Altersgruppe aktualisieren
  async updateAgeGroup(id, ageGroupData) {
    try {


      const result = await apiClient.put(`/age-groups/${id}`, ageGroupData);

      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Altersgruppe löschen
  async deleteAgeGroup(id) {
    try {


      await apiClient.delete(`/age-groups/${id}`);

      return {
        success: true,
        data: null
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Neue Funktion: Altersgruppe synchron für ein bestimmtes Alter finden
  async getAgeGroupForAgeSync(age) {
    try {
      const allAgeGroups = await this.getAllAgeGroups();
      if (!allAgeGroups.success) {
        return null;
      }

      const ageGroup = allAgeGroups.data.find(ag =>
        age >= ag.minAge && age <= ag.maxAge
      );

      return ageGroup || null;
    } catch (error) {
      console.error('Error in getAgeGroupForAgeSync:', error);
      return null;
    }
  }
}

// Singleton-Instanz exportieren
const ageGroupsService = new AgeGroupsService();
export default ageGroupsService; 